// import { dialog } from '@rynpsc/dialog';

export function init() {
	// const dialog = dialog('dialog');
	const siteNav = document.querySelector('.c-site-nav');
	const hamburgers = document.querySelectorAll('.js-nav');

	// if (dialog) {
	// 	dialog.create();
	// }

	hamburgers.forEach(el => {
		el.addEventListener('click', (e) => {
			e.currentTarget.classList.toggle('is-open');
			e.currentTarget.classList.add('was-clicked');
			siteNav.classList.toggle('is-active');
			// dialog.toggle();
			document.body.classList.toggle('js-site-nav-open');
			const isActive = document.querySelector('.c-site-nav').classList.contains('is-active');
			const openHamburger = document.querySelector('.js-nav.was-clicked');

			if (isActive) {
				siteNav.querySelector('.link').focus();
			} else {
				openHamburger.focus();
				openHamburger.classList.remove('was-clicked');
			}
		});
	});
	document.addEventListener('keyup', event => {
		if (event.code === 'Escape') {
			siteNav.classList.remove('is-active');
			hamburgers.forEach(el => {
				el.classList.remove('is-open', 'was-clicked');
			});
		}
	});

	const parentLinks = document.querySelectorAll('.js-nav-parent');
	parentLinks.forEach(el => {
		el.addEventListener('click', (e) => {
			e.stopPropagation();
			e.preventDefault();
			e.currentTarget.parentElement.parentElement.classList.toggle('is-open');
			const children = e.currentTarget.parentElement.parentElement.querySelectorAll('.children .link.child');
			if (e.currentTarget.parentElement.parentElement.classList.contains('is-open')) {
				children.forEach(child => {
					child.setAttribute('tabIndex', '');
				});
			} else {
				children.forEach(child => {
					child.setAttribute('tabIndex', '-1');
				});
			}
		});
	});
}
